/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITicketSearchResult } from './APITicketSearchResult';
import {
    APITicketSearchResultFromJSON,
    APITicketSearchResultFromJSONTyped,
    APITicketSearchResultToJSON,
} from './APITicketSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APITicketSearchResponse
 */
export interface APITicketSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APITicketSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APITicketSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APITicketSearchResult>}
     * @memberof APITicketSearchResponse
     */
    results: Array<APITicketSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APITicketSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APITicketSearchResponse interface.
 */
export function instanceOfAPITicketSearchResponse(value: object): value is APITicketSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APITicketSearchResponseFromJSON(json: any): APITicketSearchResponse {
    return APITicketSearchResponseFromJSONTyped(json, false);
}

export function APITicketSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APITicketSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APITicketSearchResponseToJSON(value?: APITicketSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APITicketSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

